module.exports = __webpack_public_path__ + "img/reset.07f4aede.png";